"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getScoreTitle = exports.calculateScoreText = void 0;
var calculateScoreText = function (score, minified) {
    if (score < 3) {
        return 'Low';
    }
    if (score < 7) {
        return minified ? 'Med' : 'Medium';
    }
    return 'High';
};
exports.calculateScoreText = calculateScoreText;
var getScoreTitle = function (scoreType) { return (scoreType ? " " + scoreType : ''); };
exports.getScoreTitle = getScoreTitle;
